import React, { useEffect } from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import _get from 'lodash/get'
import { Map } from 'immutable'
import { get as getConfig } from '../../config/index'
import { getBoundActions } from '../../actions/index'
import { getClassName, shouldRenderFeature } from './utils'

const config = getConfig()

function OptimizelyFeature (props) {
  const {
    anon,
    flag,
    children,
    noWrapper,
    variation,
    isDefault,
    disabled,
    setUseAnonUid,
    setOptimizelyFeatureMounted,
    setOptimizelyFeatureFlag,
  } = props

  const optimizelyFeatureTesting = !!_get(config, ['features', 'optimizelyFeatureTesting'])
  const shouldRender = shouldRenderFeature(props)
  const renderDefault = !optimizelyFeatureTesting && isDefault
  const classes = getClassName(variation)

  useEffect(() => {
    if (optimizelyFeatureTesting) {
      // use anon uid for optimizely feature testing
      if (anon) {
        setUseAnonUid(true)
      }
      setOptimizelyFeatureMounted(true)
      setOptimizelyFeatureFlag(flag)
    }

    return () => {
      setOptimizelyFeatureMounted(false)
    }
  }, [])

  // When Optimizely is disabled via query param, show only the default (control); hide variants

  if (disabled && isDefault) {
    if (noWrapper) {
      return (
        <>
          {children}
        </>
      )
    }

    return (
      <div className="optimizely-feature-case optimizely-feature-case--disabled">
        {children}
      </div>
    )
  }

  if (disabled && !isDefault) {
    return null
  }

  if (!shouldRender && !renderDefault) {
    return null
  }

  if (noWrapper || renderDefault) {
    return (
      <>
        {children}
      </>
    )
  }

  return (
    <div className={classes}>
      {children}
    </div>
  )
}

OptimizelyFeature.propTypes = {
  anon: PropTypes.bool,
  flag: PropTypes.string.isRequired,
  children: PropTypes.node,
  variation: PropTypes.string.isRequired,
  noWrapper: PropTypes.bool,
  isDefault: PropTypes.bool,
  disabled: PropTypes.bool,
  optimizelyFeature: PropTypes.object,
  setOptimizelyFeatureMounted: PropTypes.func,
  setOptimizelyFeatureFlag: PropTypes.func,
}

OptimizelyFeature.defaultProps = {
  isDefault: false,
  noWrapper: false,
  anon: false,
}

export default compose(
  connectRedux(
    (state) => ({
      optimizelyFeature: state.optimizelyFeature || Map(),
      disabled: Map.isMap(state.optimizelyFeature) ? state.optimizelyFeature.get('disabled') : undefined,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setOptimizelyFeatureMounted: actions.optimizelyFeature.setOptimizelyFeatureMounted,
        setOptimizelyFeatureFlag: actions.optimizelyFeature.setOptimizelyFeatureFlag,
        setUseAnonUid: actions.optimizelyFeature.setUseAnonUid,
      }
    },
  ),
)(OptimizelyFeature)
